const get = require('lodash/get');
const session = require('@flowio/session');

function getShopifyLocalizationMethod() {
  return get(session.getAttributes(), 'shopify_localization_method');
}

function isApiShopifyLocalizationMethod() {
  return getShopifyLocalizationMethod() === 'api';
}

function isSsrShopifyLocalizationMethod() {
  return getShopifyLocalizationMethod() === 'ssr';
}

module.exports = {
  getShopifyLocalizationMethod,
  isApiShopifyLocalizationMethod,
  isSsrShopifyLocalizationMethod,
};



// WEBPACK FOOTER //
// ./static/js/v0/utilities/shopify-localization-method.js